import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  WithStyles,
  withStyles,
  Divider,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Theme,
  Chip,
  Typography,
  IconButton,
  FormHelperText,
} from "@material-ui/core";
import * as React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";

import {
  SEARCH_TYPES,
  FORM_RESPONSE_TYPES,
  RETRIEVE_FROM,
  WAREHOUSE_CONTENT_RETRIEVE_FROM,
} from "../constants/constants";
import ItemSignotoriesDialog from "./ItemSignotoriesDialog";
import EditIcon from "@material-ui/icons/Edit";
import RetrieveOptionsDialog from "./RetrieveOptionsDialog";
export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_ACTION: "DIALOG_ACTION",
};
const styles = (theme: Theme) =>
  createStyles({
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    signChip: {
      padding: 5,
      margin: 5,
      width: 140,
      height: 44,
    },
  });
const validationSchema = Yup.object().shape({
  formsInput: Yup.string().required("Forms Input Label required"),
  responseType: Yup.string().required("Please select response type"),
});
interface Props extends WithStyles<typeof styles> {
  title: any;
  open: any;
  editData: any;
  handleClose: any;
  handleOnSubmit: any;
  equipments: any;
  uniqueNames: any;
  uniqueTypes: any;
  uniqueMachineNumbers: any;
  companyData: any;
}

class AddFormsInputItem extends React.Component<Props> {
  state = {
    hasError: false,
    type: "",
    indexSelected: -1,
    openAddSignitoriesItemDialog: false,
    signatureItem: {},
    editingSignature: {},
    captureRetrieveOptions: false,
    results: {
      retriveOptionFrom: "",
      retrieveElement: "",
      secondaryRetriveElement: "",
      retrieveItems: Array<any>(),
    },
  };

  componentDidMount = () => {
    this.setState({
      results:
        this.props.editData &&
        this.props.editData.formsInput &&
        this.props.editData.retrieveDetails
          ? this.props.editData.retrieveDetails
          : {},
      editingSignature:
        this.props.editData &&
        this.props.editData.formsInput &&
        this.props.editData.signatureItem,
    });
  };

  componentDidUpdate = (prevProps: any) => {
    if (prevProps.editData.formsInput !== this.props.editData.formsInput) {
      this.setState({
        results:
          this.props.editData && this.props.editData.retrieveDetails
            ? this.props.editData.retrieveDetails
            : {},
        editingSignature:
          this.props.editData &&
          this.props.editData.formsInput &&
          this.props.editData.signatureItem,
      });
    }
  };
  handleClose = () => {
    this.setState({
      openAddSignitoriesItemDialog: false,
    });
  };
  onItemSignitoriesSubmit = (values: any) => {
    let mValues = values;
    if (this.state.editingSignature) {
      this.setState({
        signatureItem: mValues,
        editingSignature: {},
        openAddSignitoriesItemDialog: false,
      });
    } else {
      this.setState({
        signatureItem: mValues,
        openAddSignitoriesItemDialog: false,
      });
    }
  };
  renderAddSignotoriesItemDialog = () => {
    return (
      <ItemSignotoriesDialog
        title={"Add Signatories Item"}
        defaultValue={"Signature"}
        open={this.state.openAddSignitoriesItemDialog}
        companyData={this.props.companyData}
        handleClose={this.handleClose}
        editData={
          this.state.editingSignature ? this.state.editingSignature : null
        }
        handleOnSubmit={this.onItemSignitoriesSubmit}
      />
    );
  };

  renderSignotoriesChip = (item: any) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <Typography variant="subtitle1">{item.title}</Typography>
        <Typography variant="caption">{item.who}</Typography>
      </div>
    );
  };

  handleAddButton = () => {
    this.setState({
      openAddSignitoriesItemDialog: true,
    });
  };

  renderRetrieveOptions = () => {
    return (
      <RetrieveOptionsDialog
        dialogTitle={"Retrive Options"}
        onClose={() => {
          this.setState({
            captureRetrieveOptions: false,
          });
        }}
        retrieveDetails={
          this.props.editData && this.props.editData.formsInput
            ? this.state.results
            : {}
        }
        open={this.state.captureRetrieveOptions}
        companyData={this.props.companyData}
        uniqueMachineNumbers={this.props.uniqueMachineNumbers}
        uniqueNames={this.props.uniqueNames}
        uniqueTypes={this.props.uniqueTypes}
        equipments={this.props.equipments}
        onSubmit={(results: any) => {
          this.setState({
            captureRetrieveOptions: false,
            results: results,
          });
        }}
      />
    );
  };

  render() {
    const { title, open, editData, handleClose, handleOnSubmit, classes } =
      this.props;
    let signature: any = this.state.signatureItem;
    return (
      <React.Fragment>
        <Dialog
          open={open}
          keepMounted={true}
          onClose={() => handleClose()}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
        >
          <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
          <Divider />
          <DialogContent>
            <Formik
              initialValues={
                editData && editData.formsInput
                  ? editData
                  : {
                      formsInput: "",
                      responseType: "",
                      searchType: "",
                      signatureItem: {},
                      usedAsSearch: false,
                      retrieve: "",
                    }
              }
              validationSchema={validationSchema}
              validateOnMount={true}
              enableReinitialize={true}
              onSubmit={async (values, { resetForm }) => {
                values.signatureItem = this.state.signatureItem;
                values.retrieveDetails = this.state.results;
                await handleOnSubmit(values);
                resetForm();
              }}
            >
              {({
                values,
                handleChange,
                handleBlur,
                isValid,
                setFieldValue,
              }) => {
                let signatureItem: any =
                  signature && signature.title
                    ? signature
                    : values.signatureItem;
                return (
                  <Form style={{ display: "flex", flexDirection: "column" }}>
                    <TextField
                      style={{
                        width: "80%",
                        margin: 10,
                        height: 50,
                      }}
                      id={"formsInput"}
                      value={values.formsInput}
                      name={"formsInput"}
                      onChange={handleChange}
                      label={"Forms Input Label"}
                      fullWidth={true}
                    />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: 50,
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <TextField
                          style={{ margin: 10, height: 50 }}
                          select
                          id={"responseType"}
                          label={"Response Type"}
                          value={values.responseType ? values.responseType : ""}
                          onChange={(event) => {
                            setFieldValue("responseType", event.target.value);
                            if (event.target.value === "Options") {
                              this.setState({
                                captureRetrieveOptions: true,
                              });
                            }
                            if (event.target.value === "SIGNATURE") {
                              this.setState({
                                openAddSignitoriesItemDialog: true,
                              });
                            }
                          }}
                          fullWidth={true}
                        >
                          {FORM_RESPONSE_TYPES.map(
                            (option: any, index: any) => (
                              <MenuItem
                                key={index.toString()}
                                value={option.title}
                              >
                                {option.label}
                              </MenuItem>
                            )
                          )}
                        </TextField>
                        {values.responseType === "Options" &&
                          this.props.editData &&
                          this.props.editData.formsInput && (
                            <IconButton
                              style={{ height: "100%", marginTop: 10 }}
                              onClick={() =>
                                this.setState({
                                  captureRetrieveOptions: true,
                                })
                              }
                            >
                              <EditIcon
                                style={{
                                  width: 20,
                                  height: 20,
                                }}
                                fontSize={"default"}
                              />
                            </IconButton>
                          )}
                        {values.responseType === "SIGNATURE" && (
                          <IconButton
                            style={{ height: "100%", marginTop: 10 }}
                            onClick={() =>
                              this.setState({
                                openAddSignitoriesItemDialog: true,
                              })
                            }
                          >
                            <EditIcon
                              style={{
                                width: 20,
                                height: 20,
                              }}
                              fontSize={"default"}
                            />
                          </IconButton>
                        )}
                      </div>
                    </div>
                    {values.responseType !== "SIGNATURE" &&
                      values.responseType !== "Options" && (
                        <div>
                          <FormControlLabel
                            style={{
                              marginLeft: 5,
                              height: 50,
                            }}
                            control={
                              <Checkbox
                                id={"usedAsSearch"}
                                name={"usedAsSearch"}
                                checked={values.usedAsSearch}
                                onChange={(event: any) => {
                                  values.searchType = "";
                                  setFieldValue(
                                    "usedAsSearch",
                                    event.target.checked
                                  );
                                }}
                                value="usedAsSearch"
                              />
                            }
                            label="Used for Search"
                          />
                        </div>
                      )}

                    {values.usedAsSearch && (
                      <div
                        style={{
                          display: "flex",
                          width: "80%",
                          flexDirection: "column",
                        }}
                      >
                        <TextField
                          style={{ margin: 10, height: 50 }}
                          select
                          id={"searchType"}
                          label={"Search by"}
                          margin="dense"
                          value={values.searchType ? values.searchType : ""}
                          onChange={(event) => {
                            setFieldValue("searchType", event.target.value);
                          }}
                          fullWidth
                        >
                          {SEARCH_TYPES.map((option: any, index: any) => (
                            <MenuItem
                              key={index.toString()}
                              value={option.value}
                            >
                              {option.label}
                            </MenuItem>
                          ))}
                        </TextField>
                        {values.searchType !== "barcode" &&
                          values.searchType !== "serialNumber" &&
                          values.searchType !== "skuCode" && (
                            <TextField
                              style={{ margin: 10, height: 50 }}
                              select
                              id={"retrieve"}
                              label={"Correspond to:"}
                              helperText={
                                "Select the field that correspond to this field in the Employee data."
                              }
                              margin="dense"
                              value={values.retrieve ? values.retrieve : ""}
                              onChange={(event: any) => {
                                setFieldValue("retrieve", event.target.value);
                                if (event.target.value === "options") {
                                  this.setState({
                                    captureRetrieveOptions: true,
                                  });
                                }
                              }}
                              fullWidth
                            >
                              {RETRIEVE_FROM.filter((obj: any) => {
                                return (
                                  obj.value !== "none" &&
                                  obj.value !== "options" &&
                                  obj.value !== "licenseDetails"
                                );
                              }).map((option: any) => (
                                <MenuItem
                                  key={option.value}
                                  value={option.value}
                                >
                                  {option.label}
                                </MenuItem>
                              ))}
                            </TextField>
                          )}
                      </div>
                    )}
                    {(values.searchType === "barcode" ||
                      values.searchType === "serialNumber" ||
                      values.searchType === "skuCode") && (
                      <div style={{ marginLeft: 5 }}>
                        <TextField
                          style={{ margin: 10, height: 50 }}
                          select
                          id={"retrieve"}
                          label={"Correspond to:"}
                          helperText={
                            "Select the field that correspond to this field in the Employee data."
                          }
                          margin="dense"
                          value={values.retrieve ? values.retrieve : ""}
                          onChange={(event: any) => {
                            setFieldValue("retrieve", event.target.value);
                            if (event.target.value === "options") {
                              this.setState({
                                captureRetrieveOptions: true,
                              });
                            }
                          }}
                          fullWidth
                        >
                          {WAREHOUSE_CONTENT_RETRIEVE_FROM.filter(
                            (obj: any) => {
                              return (
                                obj.value !== "none" &&
                                obj.value !== "options" &&
                                obj.value !== "licenseDetails"
                              );
                            }
                          ).map((option: any) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </TextField>
                        <FormControlLabel
                          style={{
                            height: 50,
                          }}
                          control={
                            <Checkbox
                              id={"warehouseContent"}
                              name={"warehouseContent"}
                              checked={values.warehouseContent}
                              onChange={(event: any) => {
                                setFieldValue(
                                  "warehouseContent",
                                  event.target.checked
                                );
                              }}
                              value="warehouseContent"
                            />
                          }
                          label="Warehouse Content"
                        />
                        <Typography
                          variant="caption"
                          display="block"
                          gutterBottom
                        >
                          Tick for Warehouse Content.
                        </Typography>
                      </div>
                    )}
                    {signatureItem && signatureItem.title && (
                      <Chip
                        size="medium"
                        className={classes.signChip}
                        onDelete={() =>
                          this.setState({
                            signatureItem: {},
                          })
                        }
                        label={this.renderSignotoriesChip(signatureItem)}
                        avatar={
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <IconButton
                              onClick={() => {
                                this.setState({
                                  editingSignature: signatureItem,
                                  openAddSignitoriesItemDialog: true,
                                });
                              }}
                            >
                              <EditIcon
                                style={{
                                  width: 15,
                                  height: 15,
                                }}
                                fontSize={"small"}
                              />
                            </IconButton>
                          </div>
                        }
                      />
                    )}
                    <DialogActions>
                      <Button
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        {"CANCEL"}
                      </Button>
                      <Button type="submit" disabled={!isValid}>
                        {"SAVE"}
                      </Button>
                    </DialogActions>
                  </Form>
                );
              }}
            </Formik>
          </DialogContent>
        </Dialog>
        {this.renderAddSignotoriesItemDialog()}
        {this.renderRetrieveOptions()}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AddFormsInputItem);
